// export const config = {
//   "--vant-sg-main-color": ["#2878FF","#FF8E2D"]
// }
export var config = {
  themeBlue: {
    '--vant-sg-main-color': '#2878FF'
  },
  themeYellow: {
    '--vant-sg-main-color': '#FF8E2D'
  }
};